import React, { useState, useEffect } from 'react';
import Modal from './ModalConversion';
import MonthPicker from './MonthPicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const ExchangeRateModal = ({ isOpen, onClose, rate, onSave, saving }) => {
    const [form, setForm] = useState({
        type: 'USD_MXN',
        period: '',
        value: '',
        currency: 'GBP'
    });
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            setError('');
            if (rate) {
                setForm({
                    type: rate.type,
                    period: rate.period,
                    value: String(rate.value),
                    currency: rate.currency || 'GBP'
                });
            } else {
                setForm({
                    type: 'USD_MXN',
                    period: '',
                    value: '',
                    currency: 'GBP'
                });
            }
        }
    }, [isOpen, rate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
        if (error) setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.period || !/^\d{4}-\d{2}$/.test(form.period)) {
            setError('Selecciona el año y el mes del periodo');
            return;
        }
        setError('');
        const result = await onSave(form);
        if (result && !result.ok && result.msg) {
            setError(result.msg);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="sm">
            <div className="p-3">
                <h3 className="mb-4 text-white">
                    {rate ? 'Editar tipo de cambio' : 'Agregar tipo de cambio'}
                </h3>

                {error && (
                    <div
                        className="mb-3 py-2 px-3 rounded d-flex align-items-center gap-2"
                        role="alert"
                        style={{
                            background: 'rgba(239,68,68,0.15)',
                            border: '1px solid rgba(239,68,68,0.6)',
                            color: '#fecaca',
                            fontSize: '0.875rem',
                        }}
                    >
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <span>{error}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3 text-start">
                        <label className="mb-1 fw-bold text-white">Tipo de cambio</label>
                        <select
                            name="type"
                            className="form-select bg-dark text-white border-secondary py-2"
                            value={form.type}
                            onChange={handleChange}
                            disabled={!!rate}
                        >
                            <option value="USD_MXN">USD_MXN</option>
                            <option value="INGRAM">INGRAM</option>
                        </select>
                    </div>

                    <div className="form-group mb-3 text-start">
                        <MonthPicker
                            label="Periodo"
                            value={form.period}
                            onChange={(value) => {
                                setForm(prev => ({ ...prev, period: value }));
                                if (error) setError('');
                            }}
                        />
                    </div>

                    <div className="form-group mb-3 text-start">
                        <label className="mb-1 fw-bold text-white">Valor</label>
                        <input
                            type="number"
                            name="value"
                            className="form-control bg-dark text-white border-secondary py-2"
                            placeholder="Ej: 17.25"
                            step="0.0001"
                            min="0"
                            value={form.value}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {form.type === 'INGRAM' && (
                        <div className="form-group mb-3 text-start">
                            <label className="mb-1 fw-bold text-white">Moneda</label>
                            <select
                                name="currency"
                                className="form-select bg-dark text-white border-secondary py-2"
                                value={form.currency}
                                onChange={handleChange}
                            >
                                <option value="GBP">GBP</option>
                                <option value="USD">USD</option>
                                <option value="EUR">EUR</option>
                            </select>
                        </div>
                    )}

                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>Cancelar</button>
                        <button type="submit" className="btn btn-primary" disabled={saving}>
                            {saving ? (
                                <>
                                    <FontAwesomeIcon icon={faSync} spin className="me-2" />
                                    Guardando...
                                </>
                            ) : 'Guardar'}
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default ExchangeRateModal;
